var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 31.775c-8.0858 0-14.751-6.0833-15.668-13.923h3.5976v-3.593h-3.6104c0.86626-7.8936 7.5562-14.035 15.681-14.035 8.1243 0 14.814 6.1415 15.68 14.035h-3.6103v3.593h3.5976c-0.9171 7.8395-7.582 13.923-15.668 13.923zm-4.7509-26.997c-1.5402 2.7501-2.5205 5.9943-2.7668 9.4809h-4.5413c0.61255-4.2824 3.4522-7.8463 7.3082-9.4809zm-2.7586 13.074h-4.533c0.64574 4.2324 3.4694 7.7484 7.2916 9.3687-1.5237-2.7205-2.4994-5.9247-2.7586-9.3687zm12.26 9.3687c1.5237-2.7205 2.4994-5.9247 2.7586-9.3687h4.533c-0.6458 4.2324-3.4694 7.7484-7.2916 9.3687zm7.3082-12.962c-0.6126-4.2824-3.4523-7.8464-7.3082-9.4809 1.5402 2.7501 2.5205 5.9943 2.7668 9.4809h4.5414zm-8.1447 0h-7.8288c0.3322-4.0124 1.7979-7.538 3.9144-10.09 2.1164 2.5521 3.5822 6.0776 3.9144 10.09zm-0.0096 3.593h-7.8096c0.3501 3.9659 1.8081 7.4496 3.9048 9.9778 2.0967-2.5282 3.5547-6.0119 3.9048-9.9778z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.8ae4b9226f764e7a2e9990e13832d396.svg";
export { ForwardRef as ReactComponent };